<script lang="ts">
    export let initials: string = '';

    const MAX = 10000;
    const MIN = 1;
    const id = Math.floor(Math.random() * (MAX - MIN) + MIN);
</script>

<!-- TODO: rdar://93671952 (JMOTW: VO: Make sure monograms have context) -->
<svg class="monogram" viewBox="0 0 640 640" xmlns="http://www.w3.org/2000/svg"
    ><defs
        ><linearGradient
            id={`monogram-bg-${id}`}
            x1="50%"
            y1="0%"
            x2="50%"
            y2="100%"
            ><stop offset="0%" stop-color="#A5ABB8" /><stop
                offset="100%"
                stop-color="#848993"
            /></linearGradient
        ></defs
    ><rect width="100%" height="100%" fill={`url(#monogram-bg-${id})`} /><text
        x="320"
        y="50%"
        dy="0.35em"
        font-size="310"
        letter-spacing="3"
        fill="#fff"
        text-anchor="middle">{initials}</text
    ></svg
>

<style lang="scss">
    @use '@amp/web-shared-styles/sasskit-stylekit/ac-sasskit-config';
    @use 'amp/stylekit/core/fonts' as *;
    @use 'amp/stylekit/core/typography' as *;
    @use 'amp/stylekit/core/mixins/browser-targets' as *;

    // Override Typespec
    // TODO: Remove with integration of rdar://93627371 (@amp/stylekit: Update monogram typespec)
    @include typespec-set(Monogram, 310, 1, medium, 0, rounded);

    .monogram {
        border-radius: inherit;
        display: block;
        width: var(--artwork-override-width);
        height: 100%;

        // Set font-weight for fallback
        font-weight: 500; // medium

        @include target-safari {
            // Apply `ui-rounded` font to monogram
            font: var(--monogram);
        }
    }
</style>
